module.exports = __webpack_public_path__ + "img/MESSAGE.e1046177.svg";